module.exports = __webpack_public_path__ + "img/care-offer-4.a9bc7b26.jpg";